module.exports = __webpack_public_path__ + "img/heroBg.cac162b4.png";